import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import LinkStats from './components/LinkStats';
import { AuthProvider, useAuth } from './context/AuthContext';
import api from './services/api';
import './App.css';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div className="loading">Carregando...</div>;
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};

const StatsPage = () => {
  const { linkId } = useParams();
  const { isAuthenticated, loading: authLoading } = useAuth();
  const [link, setLink] = useState(null);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!authLoading && isAuthenticated && linkId) {
      fetchLinkAndStats();
    }
  }, [linkId, isAuthenticated, authLoading]);

  const fetchLinkAndStats = async () => {
    try {
      setLoading(true);
      // Buscar o link primeiro
      const linkResponse = await api.get(`/links/${linkId}`);
      setLink(linkResponse.data);

      // Buscar estatísticas
      const statsResponse = await api.get(`/stats/link/${linkId}`);
      setStats(statsResponse.data);
    } catch (err) {
      console.error('Erro ao carregar estatísticas:', err);
      setError('Não foi possível carregar as estatísticas');
    } finally {
      setLoading(false);
    }
  };

  const getShortUrl = (shortCode) => {
    const backendUrl = process.env.REACT_APP_BACKEND_URL || 
      (process.env.NODE_ENV === 'production' 
        ? window.location.origin 
        : 'http://localhost:5000');
    return `${backendUrl}/${shortCode}`;
  };

  if (authLoading || loading) {
    return <div className="loading">Carregando estatísticas...</div>;
  }

  if (error || !link) {
    return (
      <div className="loading">
        <p>{error || 'Link não encontrado'}</p>
        <a href="/" style={{ marginTop: '20px', display: 'inline-block', color: '#0ad596' }}>
          ← Voltar para Dashboard
        </a>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#e5e6e5', padding: '20px' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ background: 'white', borderRadius: '10px', padding: '30px', boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)' }}>
          <div style={{ marginBottom: '20px' }}>
            <a href="/" style={{ color: '#0ad596', textDecoration: 'none', fontSize: '16px', fontWeight: '500' }}>
              ← Voltar para Dashboard
            </a>
          </div>
          <LinkStats 
            link={link} 
            stats={stats} 
            getShortUrl={getShortUrl}
            onBack={() => window.location.href = '/'}
          />
        </div>
      </div>
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/stats/:linkId"
              element={
                <PrivateRoute>
                  <StatsPage />
                </PrivateRoute>
              }
            />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;

